export const EvaluationCopyType = {
  CDU: "CDU",
  CDA: "CDA",
} as const;

export type EvaluationCopyType =
  (typeof EvaluationCopyType)[keyof typeof EvaluationCopyType];

export const EVALUATION_COPY_CDA_TYPE_PARAM = "type";
export const EVALUATION_COPY_CDA_FAGSKOLE = "fagskole";

export const EvaluationCopyStage = {
  BOOK_SELECT: 1,
  TYPE: 2,
  FORM: 3,
  CONFIRMATION: 4,
} as const;

export type EvaluationCopyStage =
  (typeof EvaluationCopyStage)[keyof typeof EvaluationCopyStage];

export const EVALUATION_COPY_PATHS = {
  HOME: "/vurderingseksemplar",
  SELECT_BOOK: "/vurderingseksemplar/velg-boker",
  TYPE_SELECTION: "/vurderingseksemplar/velg-niva",
  CDA: "/vurderingseksemplar/cda",
  CDU: "/vurderingseksemplar/cdu",
  CONFIRMATION: "/vurderingseksemplar/bekreftelse",
};
